// Count Input Digits from InputFields and return.
// Is Used for set custom class to make the output smaler.
export const digitCalculation = input => {
  return (Math.log10((input ^ (input >> 31)) - (input >> 31)) | 0) + 1;
};
